/*****
 * Initialize FontFace Observer and load deferred fonts
 * https://digital.vfc.com/wiki/display/VFDP/Deferred+Font+Loading
 *****/
define([
	'require',
	'jquery',
	'domReady',
	'pubsub'
], function(require, $, domReady) {

	var PLUGIN_IDENTIFIER = "fontLoader";
	var fontLoader = function( element, options, pubsub) {
		this.element = $(element);
		this.options = options;
		
		// This next line takes advantage of HTML5 data attributes
		// to support customization of the plugin on a per-element
		// basis. For example,
		// <footer class='footer' data-footer-options='{"message":"Goodbye World!"}'></section>
		this.metadata = $(this.element).data('fontloader-options');
	};

	fontLoader.prototype = {
		defaults: {
			fontList: '/_jcr_content.fonts.json'
		},

		init: function() {
			console.debug('Initializing deferred font loading.');

			var self = this;

			// Merge the various ways of providing options
			self.config = $.extend( {},
				self.defaults,
				self.options,
				self.metadata
			);

			// Base path default is /homepage, window.currentPath is used for CMS authoring
			var basePath = (window && window.currentPath) ? window.currentPath : '/homepage';

			self.config.fontList = basePath + self.config.fontList;

			// TODO: Passing an object for self.config.fontlist would
			// allow for bypassing the need to make an AJAX call and
			// improve performance. Adding a switch(self.config.fontlist)
			// would allow for automatic detection of a list or a URL
			// and loadFonts() could be called directly

			self.getFontList();

			return self; // Allow chaining
		},


		/**
		 * Asynchrnously load the web font files
		 **/
		loadFonts: function() {
			var self = this;

			require(['fontfaceobserver'],function(ffobsever) {

				// Setup a loader for each font
				var fontObservers = self.config.fontList.map(function(el) {
					return new FontFaceObserver(el.font);
				});

				// Load all listed fonts and set a class on the HTML when done
				Promise.all(fontObservers.map(function(obj) {
					return obj.load();
				})).then(function() {
					$('html').addClass('fonts-loaded');
					$.pubsub('publish','vfdp.fonts.loaded');
				},function(err) {
					console.error('Error loading font',err);
					$.pubsub('publish','vfdp.fonts.error',err);
				});
			});
		},

		/**
		 * Get the list of fonts for deferred loading
		 */
		getFontList: function() {
			var self = this;

			$.ajax({
				url: self.config.fontList, 
				dataType: 'json',
				type: 'GET',
				error: function(jqXHR, textStatus, errorThrown) {
					console.error('Deferred webfonts failed to load with error: ',textStatus,errorThrown);
					$.pubsub('publish','vfdp.fonts.error',err);
				},
				success: function(data) {
					var fonts = [],
					font;
					
					// parse the JSON response and filter to only fonts marked for loading
					for(font in data) {
						if(font.deferredLoading){
							fonts.push(font);
						}
					}

					self.config.fontList = fonts;

					// Trigger font loading
					self.loadFonts();
				}
			});
		}
	};

	fontLoader.defaults = fontLoader.prototype.defaults;

	$.fn.fontLoader = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new fontLoader(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};

});
